import { Tag } from "antd";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import React from "react";
import { ServiceAccountStatus } from "../../types/provider";
import { useTranslation } from "react-i18next";

interface ServiceAccountStatusTagProps {
  status: ServiceAccountStatus;
}

export const ServiceAccountStatusTag = ({
  status,
}: ServiceAccountStatusTagProps) => {
  const { t } = useTranslation();

  switch (status) {
    case "verified":
      return (
        <Tag icon={<CheckCircleOutlined />} color="success">
          {t(
            "pages.service-accounts.service-accounts-table.status-type.verified",
          )}
        </Tag>
      );
    case "processing":
      return (
        <Tag icon={<SyncOutlined spin />} color="processing">
          {t(
            "pages.service-accounts.service-accounts-table.status-type.processing",
          )}
        </Tag>
      );
    case "error":
      return (
        <Tag icon={<CloseCircleOutlined />} color="error">
          {t(
            "pages.service-accounts.service-accounts-table.status-type.invalid",
          )}
        </Tag>
      );
    case "warning":
      return (
        <Tag icon={<ExclamationCircleOutlined />} color="warning">
          {t(
            "pages.service-accounts.service-accounts-table.status-type.warning",
          )}
        </Tag>
      );
    case undefined:
      return (
        <Tag icon={<ClockCircleOutlined />} color="default">
          {t(
            "pages.service-accounts.service-accounts-table.status-type.waiting",
          )}
        </Tag>
      );
    default:
      return (
        <Tag icon={<MinusCircleOutlined />} color="default">
          {t(
            "pages.service-accounts.service-accounts-table.status-type.no-status",
          )}
        </Tag>
      );
  }
};
